// hardcoded for now, will be replaced with backend in the future
const REDIRECT_WIDGET_PARTNERS = {
  'cashcorner.com': 'lfbc', //sroi
  'moneylion.com': 'moneylion',
  'mylending-wallet.com': 'my-lending-wallet', // epcvip
}

/**
 * Resolves the submitForm reponse URL, routing matched leads
 * through the redirect widget to display branding before redirect to external partner site.
 *
 * @param {string} redirectUrl - URL returned from submitForm
 * @param {string} thanksUrl - Fallback thanks url
 * @param {string|null} [slug=null] - possibly received from backend in the future?
 * @returns {string}
 */
export function resolvePostSubmitUrl(redirectUrl, thanksUrl, slug = null) {
  const listingSlug = slug || matchPartnerDomain(redirectUrl)

  if (listingSlug) {
    const encoded = encodeURIComponent(redirectUrl)
    return `/redirect-widget/?listing=${listingSlug}&redirect=${encoded}`
  }

  return redirectUrl || thanksUrl
}

/**
 * @param {string} url
 * @returns {string|null}
 */
function matchPartnerDomain(url) {
  if (!url) return null
  // Skip any chats, thanks, and offerwall pages
  if (/\/(chat|thanks|offerwall)/i.test(url)) return null
  for (const [domain, listingSlug] of Object.entries(
    REDIRECT_WIDGET_PARTNERS,
  )) {
    if (url.includes(domain)) return listingSlug
  }
  return null
}
